import { render, staticRenderFns } from "./DependencyOccurenceInfoGroup.vue?vue&type=template&id=3fcf2450"
import script from "./DependencyOccurenceInfoGroup.vue?vue&type=script&lang=ts"
export * from "./DependencyOccurenceInfoGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DependencyOccurenceInfoItem: require('/build/apps/legacy/components/Dependencies/Occurrence/DependencyOccurenceInfoItem.vue').default,UnavailableLabel: require('/build/apps/legacy/components/Dependencies/Common/UnavailableLabel.vue').default,UILabel: require('/build/apps/legacy/components/Common/UI2/Label/UILabel.vue').default,SeverityIndicator: require('/build/apps/legacy/components/Dependencies/Common/SeverityIndicator.vue').default,ReachabilityIndicator: require('/build/apps/legacy/components/Dependencies/Common/ReachabilityIndicator.vue').default,FixabilityIndicator: require('/build/apps/legacy/components/Dependencies/Common/FixabilityIndicator.vue').default,DynamicRiskIndicator: require('/build/apps/legacy/components/Dependencies/Common/DynamicRiskIndicator.vue').default})
